<template>
    <swiper ref="categories_swiper" :options="options.categories_swiper" class="categories--list">
        <swiper-slide v-for="(item, index) in categories" v-bind:key="index" class="categories--item">
        <a :href="categoryUrl + '/' + item.id" class="categories--link">
            <img class="categories--image" :src="'/upload/brands/' + item.image" alt="">
            <div class="categories--text">{{ item.name }}</div>
        </a>
        </swiper-slide>
    </swiper>
</template>

<script>
    export default {
        props: {
            categories: Array,
            categoryUrl: {
                type: String,
                required: false
            },
        },
        data: () => ({
            // categories: [
            //     {
            //         title: 'Botulinum',
            //         link: '#',
            //         image: '/img/categories/botulinum.png'
            //     },
            //     {
            //         title: 'Dermal Fillers',
            //         link: '#',
            //         image: '/img/categories/dermal-fillers.png'
            //     },
            //     {
            //         title: 'Mesotherapy',
            //         link: '#',
            //         image: '/img/categories/mesotherapy.png'
            //     },
            //     {
            //         title: 'Lipolitics',
            //         link: '#',
            //         image: '/img/categories/lipolitics.png'
            //     },
            // ],
            options: {
                categories_swiper: {
                    pagination: {
                        el: '.swiper-pagination-categories',
                        clickable: true
                    },

                    navigation: {
                        nextEl: '.swiper-nav-categories .swiper-nav--right',
                        prevEl: '.swiper-nav-categories .swiper-nav--left'
                    },
                    centeredSlides: false,
                    slidesPerView: 1,
                    spaceBetween: 50,
                    threshold: 7,
                    breakpoints: {

                    1200: {
                        slidesPerView: 4,

                    },
                    992: {
                        slidesPerView: 3,
                    },
                    450: {
                        slidesPerView: 2,
                    },
                    640: {
                        slidesPerView: 3,
                    },
                    }
                },
            },
        }),

        mounted() {
            // console.log('Component mounted.')
        }
    }
</script>
